import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CountryLookupEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { LeadAccountAddFormComponent } from '../lead-account-add-form/lead-account-add-form.component';
import { CommonMethod } from 'src/app-core/methods/common-methods';

@Component({
    selector: 'app-quick-contact',
    templateUrl: './add-quick-contact-form.component.html',
    styleUrls: ['./add-quick-contact-form.component.scss'],
})
export class AddQuickContactComponentForm implements OnInit {
    contactData: any;
    accountId: string;
    commonDataModel = new CommonDataModel();
    pattern = new CustomPattern();
    quickContactEditForm: any = this.commonDataModel.quickContactEditModel;
    countryLookupEnum: typeof CountryLookupEnum = CountryLookupEnum;
    countries: any = [];
    copyCountriesList: any = [];
    provinces: any = [];
    isLoading = false;
    isFormLoading = false;
    pageHeader = 'Edit Quick Contact';
    commonConstants: typeof CommonConstants = CommonConstants;

    constructor(
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private contactService: ContactService,
        private toastr: ToastrService,
        public dialogRef: MatDialogRef<AddQuickContactComponentForm>,
        private dialog: MatDialog) {
        this.contactData = data;
        if (this.contactData.isCreate) {
            this.pageHeader = 'Create Quick Contact';
        }
    }

    ngOnInit() {
        this.loadItems();
    }

    loadItems(): void {

        if (this.contactData.contactId) {
            this.getCountries(false);
            this.isFormLoading = true;
            this.contactService.editQuickContact(this.contactData.contactId).subscribe(response => {
                if (response.isSuccess) {
                    const alternateContactList = response.data.alternateContacts;
                    const formattedResponse = this.commonService.getObjectValueAsString(response.data);
                    this.quickContactEditForm = formattedResponse;
                    const cId = this.quickContactEditForm.countryId;
                    const countrySelectedId: number = + cId;
                    this.quickContactEditForm.countryId = countrySelectedId;
                    this.quickContactEditForm.alternateContacts = alternateContactList;
                    if (this.quickContactEditForm.phone) {
                        this.contactData.isPhoneNumber = true;
                    }
                    this.isFormLoading = false;
                }
            });
        } else {
            this.getCountries(true);
        }
    }

    onSubmit(): void {
        this.isLoading = true;
        if (this.contactData.isCreate) {
            this.quickContactEditForm.accountId = this.contactData.accountId;
            this.contactService.createQuickContact(this.quickContactEditForm).subscribe(response => {
                if (response.isSuccess) {
                    this.toastr.success(CommonConstants.appComponent.quickaccountaddedSuccessfully);
                    this.quickContactEditForm.provinceName = this.quickContactEditForm.provinceName;
                    this.quickContactEditForm.countryName = this.countries
                        .find(item => item.id === this.quickContactEditForm.countryId).countryName;
                    this.quickContactEditForm.accountId = response.data.accountId;
                    this.quickContactEditForm.accountName = response.data.accountName;
                    this.onClose(this.quickContactEditForm);
                } else {
                    this.toastr.error(response.errors);
                }
                this.isLoading = false;
            });
        } else {
            this.quickContactEditForm.isOrderUpdate = true;
            this.quickContactEditForm.orderId = this.contactData.orderId;
            this.quickContactEditForm.contactId = this.contactData.contactId;
            this.contactService.updateQuickContact(this.quickContactEditForm).subscribe(response => {
                if (response.isSuccess) {
                    this.toastr.success(CommonConstants.appComponent.quickaccountupdatedSuccessfully);
                    this.quickContactEditForm.provinceName = this.quickContactEditForm.provinceName;
                    this.quickContactEditForm.countryName = this.countries
                        .find(item => item.id === this.quickContactEditForm.countryId).countryName;
                    this.onClose(this.quickContactEditForm);
                } else {
                    this.toastr.error(response.errors);
                }
                this.isLoading = false;
            });
        }
    }

    getCountries(isDefaultUSA: boolean): void {
        this.commonService.getCountries().subscribe(response => {
            if (response.isSuccess) {
                this.countries = response.data;
                this.copyCountriesList = response.data;
                if (isDefaultUSA) {
                    this.quickContactEditForm.countryId = this.countryLookupEnum.USA;
                } else {
                    const cId = this.quickContactEditForm.countryId;
                    const countrySelectedId: number = + cId;
                    this.quickContactEditForm.countryId = countrySelectedId;
                }
            }
        });
    }

    onChangeZip(searchText: string, getDetails: boolean): void {
        if (getDetails || (searchText && searchText.length >= 3 && this.quickContactEditForm.countryId === this.countryLookupEnum.USA)) {
            this.isFormLoading = true;
            this.commonService.getPostalCodeDetails(searchText)
                .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                    if (response.isSuccess) {
                        this.quickContactEditForm.countryId = response.data.countryId;
                        this.quickContactEditForm.province = response.data.provinceName;
                        this.quickContactEditForm.city = response.data.city;
                    } else {
                        this.toastr.warning(response.errors);
                        this.clearLocationDetails();
                    }
                    this.isFormLoading = false;
                });
        } else {
            if (!this.quickContactEditForm.isInternational) {
                this.clearLocationDetails();
            }
        }
    }

    onCountryChange() {
        if (!this.quickContactEditForm.isInternational) {
            this.quickContactEditForm.province = null;
            this.quickContactEditForm.city = null;
            this.quickContactEditForm.zipCode = null;
        }
    }

    clearLocationDetails() {
        this.quickContactEditForm.province = null;
        this.quickContactEditForm.city = '';
    }

    bindZipCode(item: any): string | undefined {
        return item ? item.zip : undefined;
    }

    onClose(addressId?: any): void {
        this.dialogRef.close(addressId);
    }

    onChangeAllowInternationalZip(event: any) {
        this.commonMethod.sendIsInternationalZipcode(event.checked);
        if (!event.checked) {
            this.quickContactEditForm.zipCode = '';
        }
    }

    onConvertToFullLead() {
        this.dialog
            .open(LeadAccountAddFormComponent, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                autoFocus: false,
                // if quick Account pass true else false
                data: { isQuickAccount: true, editQuickContactEditForm: this.quickContactEditForm }
            }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.leadId) {
                    this.getLeadDetails(response.leadId);
                }
            });
    }

    handleFilter(value: any) {
        this.countries = this.copyCountriesList.filter((s) => s.countryName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    getLeadDetails(leadId: string): void {
        this.contactService.editQuickContact(this.contactData.contactId).subscribe(response => {
            if (response.isSuccess) {
                response.data.phone = response.data.phone.replaceAll('-', '');
                const alternateContactList = response.data.alternateContacts;
                const formattedResponse = this.commonService.getObjectValueAsString(response.data);
                this.quickContactEditForm = formattedResponse;
                const cId = this.quickContactEditForm.countryId;
                const countrySelectedId: number = + cId;
                this.quickContactEditForm.countryId = countrySelectedId;
                this.quickContactEditForm.isConvertToLead = true;
                this.quickContactEditForm.alternateContacts = alternateContactList;
                this.isFormLoading = false;
                this.quickContactEditForm.provinceName = this.quickContactEditForm.provinceName;
                this.quickContactEditForm.countryName = this.countries
                    .find(item => item.id === this.quickContactEditForm.countryId).countryName;
                this.onClose(this.quickContactEditForm);
            }
        });
    }
}
